<template>
    <div class="items-center min-h-screen w-full xl:p-32 md:p-10">
        <div class="md:flex w-full xl:w-1/3 bg-white rounded shadow-lg mx-auto">
            <div class="w-full  md:w-full py-10 px-5 md:px-10">
                <div class="flex items-center">
                    <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"
                        xmlns="http://www.w3.org/2000/svg">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                            d="M18 9v3m0 0v3m0-3h3m-3 0h-3m-2-5a4 4 0 11-8 0 4 4 0 018 0zM3 20a6 6 0 0112 0v1H3v-1z"></path>
                    </svg>
                    <div class="text-right text-md">
                        View data for agent
                    </div>

                </div>
                <form class="mt-5 space-y-6" @submit.prevent="SelectAgent" novalidate>
                    <div class="rounded-sm">
                        <div class="flex flex-col">
                            <select
                                class="h-10 form-select appearance-none block w-full px-3 py-1.5 text-base font-normal 
                      text-gray-700 bg-white bg-clip-padding bg-no-repeat border border-solid border-gray-300 rounded 
                      transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
                                a ria-label="Select Agent" v-model="form.selected_agent"
                                :class="{ 'border-red-400': v$.form.selected_agent.$error }">
                                <option value="" disabled>Select Agent</option>
                                <option v-for="(item, index) in agent_list" :key="index" :value="item">
                                    {{ item.AgentName }}
                                </option>
                            </select>
                            <div class="text-red-600 mt-1 text-sm" v-for="(error, index) in v$.form.selected_agent.$errors"
                                :key="index">
                                <div v-if="error.$validator == 'required'">
                                    {{ error.$message }}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div>
                        <button id="signin" type="submit"
                            class="group relative w-full flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white cobalt-button-color focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-50"
                            aria-required="true">
                            <span class="absolute left-0 inset-y-0 flex items-center pl-3">
                                <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24"
                                    xmlns="http://www.w3.org/2000/svg">
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                        d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z">
                                    </path>
                                </svg>
                            </span>
                            <span>Select</span>
                        </button>
                    </div>
                </form>
            </div>
        </div>
    </div>
</template>
<script>
import { mapState } from "vuex";
import useVuelidate from "@vuelidate/core";
import { required } from "@vuelidate/validators";
// import { helpers } from "vuelidate/lib/validators";
// const email = helpers.regex("email",/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/);
export default {
    name: "SelectAgent",
    setup() {
        return { v$: useVuelidate() };
    },
    computed: mapState(["agent_list"]),
    data: function () {
        return {
            form: { selected_agent: "" },
        };
    },
    validations() {
        return {
            form: {
                selected_agent: {
                    required,
                },
            },
        };
    },
    methods: {
        SelectAgent: function () {
            this.v$.form.$touch(this.v$.form.errors);
            console.log(this.v$.form);
            if (this.v$.form.$pending || this.v$.form.$error) return;
            localStorage.setItem("selected_agent",JSON.stringify(this.form.selected_agent));
            this.$store.dispatch("setSelectedAgent");
            this.$router.push("/home");
        },
    },
};
</script>
  